import React, {FC} from 'react'
import {Button} from '../inputs/Button'
import {ViewMode} from './useTemplateDataEditor'

interface Props {
    hasFormEditor: boolean
    viewMode: ViewMode
    isSaving: boolean
    onEdit: () => void
    onClose: () => void
    onCancel: () => void
    onSwitchToForm: () => void
    onSwitchToJson: () => void
    onSaveJson: () => void
    onSaveForm: () => void
}

export const TemplateDataFooter: FC<Props> = ({
    hasFormEditor,
    viewMode,
    isSaving,
    onEdit,
    onClose,
    onCancel,
    onSwitchToForm,
    onSwitchToJson,
    onSaveJson,
    onSaveForm,
}) => {
    if (hasFormEditor) {
        if (viewMode === 'jsonEdit') {
            return (
                <>
                    <Button title="Switch to Form" onClick={onSwitchToForm} className="cancel-dialog-button" disabled={isSaving} />
                    <Button title="Save" onClick={onSaveJson} className="save-dialog-button" disabled={isSaving} />
                </>
            )
        }

        if (viewMode === 'formEdit') {
            return (
                <>
                    <Button title="Cancel" onClick={onCancel} className="cancel-dialog-button" disabled={isSaving} />
                    <Button title="Switch to JSON" onClick={onSwitchToJson} className="cancel-dialog-button" disabled={isSaving} />
                    <Button title="Save" onClick={onSaveForm} className="save-dialog-button" disabled={isSaving} />
                </>
            )
        }

        return (
            <>
                <Button title="Edit" onClick={onEdit} className="save-dialog-button" disabled={isSaving} />
                <Button title="Close" onClick={onClose} className="cancel-dialog-button" disabled={isSaving} />
            </>
        )
    }

    if (viewMode === 'jsonEdit') {
        return (
            <>
                <Button title="Cancel" onClick={onCancel} className="cancel-dialog-button" disabled={isSaving} />
                <Button title="Save" onClick={onSaveJson} className="save-dialog-button" disabled={isSaving} />
            </>
        )
    }

    return (
        <>
            <Button title="Edit" onClick={onEdit} className="save-dialog-button" disabled={isSaving} />
            <Button title="Close" onClick={onClose} className="cancel-dialog-button" disabled={isSaving} />
        </>
    )
}
